import type { FC } from 'react';

import type { TIconProps } from './icon.props';

const IconSearch: FC<TIconProps> = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.2"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <circle
      cx="7.33333"
      cy="7.33333"
      r="3.4"
    />
    <path
      d="M12.7334 12.7333L9.7334 9.73333"
      strokeLinecap="round"
    />
  </svg>
);

export {
  IconSearch,
};
